import { createReducer, on } from '@ngrx/store';
import { cannotFetchWebshops, fetchWebshops, webshopsFetched } from '../actions/webshop.actions';
import {
  cannotFetchPhotoGalleries,
  fetchPhotoGalleries,
  photoGalleriesFetched
} from '../actions/photo-gallery.actions';

export interface ServiceStatusState {
  isLoading: boolean;
  error: string;
}

export const initialServiceStatusState: ServiceStatusState = {
  error: '',
  isLoading: false
}

export const serviceStatusReducer = createReducer(
  initialServiceStatusState,
  on(fetchWebshops, (state) => ({isLoading: true, error: ''})),
  on(webshopsFetched, (state, {payload}) => ({isLoading: false, error: ''})),
  on(cannotFetchWebshops, (state, {error}) => ({isLoading: false, error})),
  on(fetchPhotoGalleries, (state) => ({isLoading: true, error: ''})),
  on(photoGalleriesFetched, (state, {payload}) => ({isLoading: false, error: ''})),
  on(cannotFetchPhotoGalleries, (state, {error}) => ({isLoading: false, error})),
);
